import { IS_PRODUCTION, TCHOP_ROOT_URL } from '../../env';
import { getChannelDomain } from './getChannelDomain';
import { getChannelNameFromCookie } from './getChannelNameFromCookie';
import { getOrganisationDomain } from './getOrganisationDomain';

export const getChannelUrl = (): string => {
  if (!IS_PRODUCTION) {
    return '/channel/api/';
  }

  const organisation = getOrganisationDomain();
  const { host, protocol } = new URL(TCHOP_ROOT_URL);
  const channelCustomDomain = getChannelNameFromCookie();

  if (channelCustomDomain) {
    return `${protocol}//${channelCustomDomain}-${organisation}.${host}/api`;
  }

  const channel = getChannelDomain();

  if (!channel) {
    return '/';
  }

  return `${protocol}//${channel}-${organisation}.${host}/api`;
};
